import { Component, Input, OnInit } from '@angular/core';
import { ITableItem, TableCellComponent } from '@captiveaire/table';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { ControlSettingTemplatesService } from '../shared/services/control-setting-templates.service';

@Component({
    selector: 'dl-templating-tree-view-cell',
    templateUrl: './control-setting-templates-tree-view-cell.component.html',
    styleUrls: ['./control-setting-templates-tree-view-cell.component.scss']
})
export class ControlSettingTemplatesTreeViewCellComponent extends TableCellComponent implements OnInit {
    @Input() public item: CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesViewModel & ITableItem;

    public treeControl = new NestedTreeControl<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesNodeViewModel>(node => node.children);
    public dataSource = new MatTreeNestedDataSource<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesNodeViewModel>();

    public hasChild = (_: number, node: CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesNodeViewModel) => !!node.children && node.children.length > 0;

    private selectedNodeData: CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesNodeViewModel;

    constructor(
        private controlSettingTemplatesService: ControlSettingTemplatesService
    ) {
        super();
    }

    public ngOnInit() {
        this.dataSource.data = this.item.templateTree;

        this.treeControl.dataNodes = this.item.templateTree;

        //this.treeControl.expandAll();

    }

    public nodeSelected(nodeData: CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesNodeViewModel) {
        if (this.selectedNodeData != null) {
            var oldelem = document.getElementById("x" + this.selectedNodeData.id);
            if (oldelem != null) {
                oldelem.style.border = "";
            }
        }


        // only can add that when particular folder selected
        this.selectedNodeData = nodeData;
        var newelem = document.getElementById("x" + this.selectedNodeData.id);
        newelem.style.border = "ridge";

    }

}
